export default __webpack_public_path__ + "static/media/image18.2edc9984.jpg";